module.exports = __webpack_public_path__ + "static/media/circle-cloud-2.79562098.png";